"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidDrillOriginAttributes = exports.isDrillConfigured = exports.getLocalIdentifierOrDie = exports.getDrillOriginLocalIdentifier = exports.filterDrillsByDrillEvent = exports.getDrillSourceLocalIdentifierFromEvent = exports.getLocalIdentifiersFromEvent = exports.getDrillsBySourceLocalIdentifiers = exports.getImplicitDrillsWithPredicates = exports.getAttributeIdentifiersPlaceholdersFromUrl = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var first_1 = tslib_1.__importDefault(require("lodash/first"));
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var drills_1 = require("@gooddata/sdk-backend-spi/dist/deprecated/dashboard/drills");
Object.defineProperty(exports, "getAttributeIdentifiersPlaceholdersFromUrl", { enumerable: true, get: function () { return drills_1.getAttributeIdentifiersPlaceholdersFromUrl; } });
function widgetDrillToDrillPredicates(drill) {
    var origin;
    if (sdk_model_1.isDrillFromMeasure(drill.origin)) {
        origin = drill.origin.measure;
    }
    else if (sdk_model_1.isDrillFromAttribute(drill.origin)) {
        origin = drill.origin.attribute;
    }
    else {
        throw new sdk_backend_spi_1.UnexpectedError("Unknown drill origin!");
    }
    // add drillable items for all three types of objRefs that the origin measure can be
    return compact_1.default([
        sdk_model_1.isLocalIdRef(origin) && sdk_ui_1.HeaderPredicates.localIdentifierMatch(origin.localIdentifier),
        sdk_model_1.isIdentifierRef(origin) && sdk_ui_1.HeaderPredicates.identifierMatch(origin.identifier),
        sdk_model_1.isUriRef(origin) && sdk_ui_1.HeaderPredicates.uriMatch(origin.uri),
    ]);
}
function insightWidgetImplicitDrills(insightWidgetDrills) {
    return insightWidgetDrills.map(function (drill) {
        return {
            drillDefinition: drill,
            predicates: widgetDrillToDrillPredicates(drill),
        };
    });
}
function insightDrillDownImplicitDrills(possibleDrills, attributesWithDrillDown) {
    var drillsWitDrillDown = possibleDrills.filter(function (candidate) {
        return attributesWithDrillDown.some(function (attr) {
            return sdk_model_1.areObjRefsEqual(attr.attribute.ref, candidate.attribute.attributeHeader.formOf.ref);
        });
    });
    return drillsWitDrillDown.map(function (drill) {
        var matchingCatalogAttribute = attributesWithDrillDown.find(function (attr) {
            return sdk_model_1.areObjRefsEqual(attr.attribute.ref, drill.attribute.attributeHeader.formOf.ref);
        });
        return {
            drillDefinition: {
                type: "drillDown",
                origin: sdk_model_1.localIdRef(drill.attribute.attributeHeader.localIdentifier),
                target: matchingCatalogAttribute.attribute.drillDownStep,
            },
            predicates: [
                sdk_ui_1.HeaderPredicates.localIdentifierMatch(drill.attribute.attributeHeader.localIdentifier),
            ],
        };
    });
}
/**
 * Returns a collection of pairs consisting of a drill definition and all its predicates.
 *
 * @param insightWidgetDrills - drills from the insight widget itself
 * @param possibleDrills - possible drill targets returned by pushData (this contains all attributes in the visualization)
 * @param attributesWithDrillDown - all the attributes in the catalog that have drill down step defined
 */
function getImplicitDrillsWithPredicates(insightWidgetDrills, possibleDrills, attributesWithDrillDown, disableWidgetDrills) {
    var drills = insightDrillDownImplicitDrills(possibleDrills, attributesWithDrillDown);
    if (!disableWidgetDrills) {
        drills = tslib_1.__spread(drills, insightWidgetImplicitDrills(insightWidgetDrills));
    }
    return drills;
}
exports.getImplicitDrillsWithPredicates = getImplicitDrillsWithPredicates;
function getDrillsBySourceLocalIdentifiers(widgetDrillDefinition, drillSourceLocalIdentifiers) {
    return widgetDrillDefinition.filter(function (d) {
        return sdk_model_1.isDrillToLegacyDashboard(d) ||
            drillSourceLocalIdentifiers.includes(getDrillOriginLocalIdentifier(d));
    });
}
exports.getDrillsBySourceLocalIdentifiers = getDrillsBySourceLocalIdentifiers;
function getLocalIdentifiersFromEvent(drillEvent) {
    var _a;
    var drillIntersection = ((_a = drillEvent === null || drillEvent === void 0 ? void 0 : drillEvent.drillContext) === null || _a === void 0 ? void 0 : _a.intersection) || [];
    return drillIntersection.map(function (x) { return x.header; }).map(sdk_ui_1.getMappingHeaderLocalIdentifier);
}
exports.getLocalIdentifiersFromEvent = getLocalIdentifiersFromEvent;
var getMeasureLocalIdentifier = function (drillEvent) {
    var _a;
    return first_1.default((((_a = drillEvent === null || drillEvent === void 0 ? void 0 : drillEvent.drillContext) === null || _a === void 0 ? void 0 : _a.intersection) || [])
        .map(function (intersection) { return intersection.header; })
        .filter(sdk_model_1.isMeasureDescriptor)
        .map(sdk_ui_1.getMappingHeaderLocalIdentifier));
};
function getDrillSourceLocalIdentifierFromEvent(drillEvent) {
    var localIdentifiersFromEvent = getLocalIdentifiersFromEvent(drillEvent);
    if (drillEvent.drillContext.type === "table") {
        /*
        For tables, the event is always triggered on the individual column and there is no hierarchy involved.
        */
        var measureLocalIdentifier = getMeasureLocalIdentifier(drillEvent);
        return [measureLocalIdentifier ? measureLocalIdentifier : last_1.default(localIdentifiersFromEvent)];
    }
    return localIdentifiersFromEvent;
}
exports.getDrillSourceLocalIdentifierFromEvent = getDrillSourceLocalIdentifierFromEvent;
function filterDrillsByDrillEvent(drillDefinitions, drillEvent) {
    if (!drillDefinitions || !drillEvent) {
        return [];
    }
    var drillSourceLocalIdentifiers = getDrillSourceLocalIdentifierFromEvent(drillEvent);
    return getDrillsBySourceLocalIdentifiers(drillDefinitions, drillSourceLocalIdentifiers);
}
exports.filterDrillsByDrillEvent = filterDrillsByDrillEvent;
function getDrillOriginLocalIdentifier(drillDefinition) {
    var origin = drillDefinition.origin;
    if (sdk_model_1.isLocalIdRef(origin)) {
        return origin.localIdentifier;
    }
    if (sdk_model_1.isDrillFromMeasure(origin)) {
        return getLocalIdentifierOrDie(origin.measure);
    }
    if (sdk_model_1.isDrillFromAttribute(origin)) {
        return getLocalIdentifierOrDie(origin.attribute);
    }
    throw new Error("InsightDrillDefinition has invalid drill origin");
}
exports.getDrillOriginLocalIdentifier = getDrillOriginLocalIdentifier;
function getLocalIdentifierOrDie(ref) {
    if (sdk_model_1.isLocalIdRef(ref)) {
        return ref.localIdentifier;
    }
    throw new Error("Invalid ObjRef invariant expecting LocalIdRef");
}
exports.getLocalIdentifierOrDie = getLocalIdentifierOrDie;
function isDrillConfigured(drill, configuredDrills) {
    if (sdk_model_1.isDrillToLegacyDashboard(drill)) {
        return false;
    }
    return configuredDrills.some(function (configDrill) {
        if (sdk_model_1.isDrillToLegacyDashboard(configDrill)) {
            return false;
        }
        return isEqual_1.default(drill, configDrill);
    });
}
exports.isDrillConfigured = isDrillConfigured;
function getValidDrillOriginAttributes(supportedItemsForWidget, localIdentifier) {
    var _a, _b, _c;
    var measureItems = (_a = supportedItemsForWidget.measures) !== null && _a !== void 0 ? _a : [];
    var measureSupportedItems = measureItems.find(function (item) { return item.measure.measureHeaderItem.localIdentifier === localIdentifier; });
    if (measureSupportedItems) {
        return measureSupportedItems.attributes;
    }
    var attributeItems = (_b = supportedItemsForWidget.attributes) !== null && _b !== void 0 ? _b : [];
    var attributeSupportedItems = attributeItems.find(function (attrItem) { return attrItem.attribute.attributeHeader.localIdentifier === localIdentifier; });
    return (_c = attributeSupportedItems === null || attributeSupportedItems === void 0 ? void 0 : attributeSupportedItems.intersectionAttributes) !== null && _c !== void 0 ? _c : [];
}
exports.getValidDrillOriginAttributes = getValidDrillOriginAttributes;
//# sourceMappingURL=drillingUtils.js.map